
<div class="add-custom-track">
  <div class="row-group">
    <div class="dialog-header">
      <div class="add-your-annotation">Find residue or range</div>
      <img class="row-child" alt="" src="assets/img/toastclose.svg" width="16" (click)="onClose()" />
    </div>
    <div class="dialog-body">
      <div class="track-one">
        <div class="text-field">
          <div class="model-coordinates">Start</div>
          <div class="text-field-inner">
            <input class="vf-form__input input-text" type="text" name="start" [ngClass]="{ 'input-error': startErrors.length > 0 }"  [(ngModel)]="start" value="" placeholder="1" (input)="onResidueInput('start')" />
            <!-- <div class="input-text-wrapper"></div> -->
          </div>
          @if (startErrors.length > 0) {
            <p class="error-message">{{ startErrors[0] }}</p>
          }
        </div>
        <div class="text-field">
          <div class="model-coordinates">End</div>
          <div class="text-field-inner">
            <input class="vf-form__input input-text" type="text" name="end"  [ngClass]="{ 'input-error': endErrors.length > 0 }" [(ngModel)]="end"  value="" [placeholder]="sequenceLength" (input)="onResidueInput('end')" />
            <!-- <div class="input-text-wrapper"> </div> -->
          </div>
          @if (endErrors.length > 0) {
            <p class="error-message">{{ endErrors[0] }}</p>
          }
        </div>
      </div>

    </div>
    <div class="dialog-footer">
      <div class="button-wrapper" id="frameContainer">
        <a class="button-secondary vf-button vf-button--secondary vf-button--sm" (click)="onZoom('highlight')">Highlight</a>
        <a class="button-primary vf-button vf-button--primary vf-button--sm" (click)="onZoom('zoom')">Zoom</a>
      </div>
    </div>
  </div>
</div>


